import { Dialog, DialogContent } from "@mui/material";

import { NavatticEmbed } from "../../../Components/NavatticEmbed";

interface NavatticDialogProps {
  open: boolean;
  onClose: () => void;
}

export const NavatticDialog = ({ open, onClose }: NavatticDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullScreen
    sx={{
      "& .MuiDialog-paper": {
        height: "calc(100vh - 64px)",
        width: "calc(100vw - 64px)",
      },
    }}
  >
    <DialogContent>
      <NavatticEmbed id="cm85zio6b000003l51c5cchhh" buttonText="Take a self-guided tour" />
    </DialogContent>
  </Dialog>
);
